import { motion } from 'framer-motion';
import { RARITY_META } from '../lib/rarity';

const PARTICLES = {
  uncommon: 4,
  rare: 6,
  epic: 8,
  legendary: 10,
  mythic: 14,
};

export default function RarityBadge({ rarity = 'common', size = 'md', showParticles = true, ...rest }) {
  const meta = RARITY_META[rarity] || RARITY_META.common;
  const dims = size === 'lg' ? 'px-5 py-2 text-sm' : size === 'sm' ? 'px-2.5 py-0.5 text-[10px]' : 'px-4 py-1.5 text-xs';
  const particleCount = PARTICLES[rarity] || 0;

  const isMythic = rarity === 'mythic';
  const isLegendary = rarity === 'legendary';
  const isEpic = rarity === 'epic';

  return (
    <div className="relative inline-flex" {...rest} data-rarity={rarity}>
      {showParticles && particleCount > 0 && (
        <div className="absolute inset-0 pointer-events-none">
          {[...Array(particleCount)].map((_, i) => (
            <motion.span
              key={i}
              className="absolute w-1 h-1 rounded-full"
              style={{
                left: `${(i * 37) % 100}%`,
                top: `${(i * 53) % 100}%`,
                background: isMythic ? `hsl(${(i * 47) % 360}, 90%, 65%)` : meta.glow || meta.color,
                boxShadow: `0 0 8px ${meta.glow || meta.color}`,
              }}
              animate={{
                opacity: [0, 1, 0],
                scale: [0.4, 1.4, 0.4],
                y: [0, -8, -14],
              }}
              transition={{ duration: 1.6 + (i % 5) * 0.15, delay: i * 0.08, repeat: Infinity, ease: 'easeOut' }}
            />
          ))}
        </div>
      )}

      <motion.span
        initial={{ scale: 0.7, opacity: 0 }}
        animate={{ scale: 1, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 20 }}
        className={`relative inline-flex items-center gap-1.5 rounded-full font-medium uppercase tracking-[0.2em] ${dims} ${
          isMythic ? 'rarity-badge-mythic'
          : isLegendary ? 'rarity-badge-legendary'
          : isEpic ? 'rarity-badge-epic'
          : ''
        }`}
        style={{
          color: isMythic ? '#fff' : meta.color,
          backgroundColor: isMythic || isLegendary || isEpic ? undefined : `${meta.color}22`,
          border: isMythic ? 'none' : `1px solid ${meta.color}66`,
          boxShadow: meta.glow ? `0 0 12px ${meta.glow}66` : undefined,
        }}
      >
        {meta.label}
      </motion.span>
    </div>
  );
}
